import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const styles = theme => ({
    arrow: {
        position: 'absolute',
        top: '50%',
        cursor: 'pointer',
        zIndex: 1
    },
    leftArrow: {
        left: -25
    },
    rightArrow: {
        right: -25
    },
});

const ArrowButton = (props) => {
    const { classes, style, onClick, direction='left' } = props;
    return (
        <IconButton onClick={onClick} className={`${classes.arrow} ${classes[`${direction}Arrow`]}`} style={{...style}}>
            {direction === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
    )
}

ArrowButton.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ArrowButton);